import { RerunCount } from './types';
import styles from './PriceListRerunCard.module.scss';

type RerunCountListProps = {
  items: RerunCount[];
};

export const RerunCountList = ({ items }: RerunCountListProps) => (
  <ul className={styles.counts}>
    {items.map(item => (
      <li key={item.label} className={item.tone ? styles[item.tone] : undefined}>
        <strong>{item.value}</strong>
        <span>{item.label}</span>
      </li>
    ))}
  </ul>
);
